export const STORAGE_KEYS = {
    TOKEN: 'auth_token',
    USER: 'user_data',
};

export const ROUTES = {
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    ASSETS: '/assets',
    OPERATORS: '/operators',
    PROJECTS: '/projects',
    ASSIGNMENTS: '/assignments',
    FUEL_LOGS: '/fuel-logs',
    MAINTENANCE: '/maintenance',
    DOCUMENTS: '/documents',
    LOCATIONS: '/locations',
    CUSTOMERS: '/customers',
    VENDORS: '/vendors',
    SUB_CONTRACTORS: '/sub-contractors',
    MATERIAL_CATEGORIES: '/material-categories',
    LABORS: '/labors',
    USERS: '/users',
    PROFILE: '/profile',
    SETTINGS: '/settings',
    HOME: '/',
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 422,
    SERVER_ERROR: 500,
};
